import { TableHeader, TableHeaderCell } from '@hivewatch/dark'

import { SOPsColumnIProps } from './Columns'

export const SOPsTableHeader = ({
  columns,
}: {
  columns: SOPsColumnIProps[]
}) => {
  return (
    <TableHeader>
      {columns.map((col) => (
        <TableHeaderCell column={col.sortColumn} key={col.key} {...col.style}>
          {col.header}
        </TableHeaderCell>
      ))}
    </TableHeader>
  )
}
